import { render, staticRenderFns } from "./SelectAnoSemestreComponent.vue?vue&type=template&id=6e8a4154&scoped=true&"
import script from "./SelectAnoSemestreComponent.vue?vue&type=script&lang=js&"
export * from "./SelectAnoSemestreComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectAnoSemestreComponent.vue?vue&type=style&index=0&id=6e8a4154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8a4154",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
